import React, { Component } from 'react';
import { m } from '../../utils';

class TimeCard extends Component {
  handleClick = shift => {
    const { isAvailable, selected, toggleShiftList } = this.props;

    if (isAvailable) {
      if (!selected) {
        toggleShiftList(shift, false);
      } else {
        toggleShiftList(shift, true);
      }
    }
  };
  className = () => {
    const { isAvailable, isOverlapped, selected } = this.props;
    if (isAvailable) {
      if (isOverlapped && !selected) {
        return '_overlapped';
      }
      if (selected) {
        return '_selected';
      }
      return '_active';
    }
    return '_disabled';
  };

  render() {
    const {
      isAvailable,
      day,
      duration,
      endDatetime,
      isOverlapped,
      selected,
      startDatetime,
      startTime,
      uid,
      tier,
    } = this.props;

    const shift = {
      uid,
      date: m(day).format(),
      startTime: startDatetime.format(),
      endTime: endDatetime.format(),
      vehicleClass: tier,
    };

    return (
      <div
        className={`time-card time-card${this.className()}`}
        role="button"
        tabIndex={0}
        onClick={isAvailable && !selected && !isOverlapped ? () => this.handleClick(shift) : () => {}}>
        <span>
          {m()
            .hour(startTime)
            .format('hA')}{' '}
          -{' '}
          {m()
            .hour(startTime)
            .add(duration, 'hours')
            .format('hA')}
        </span>
      </div>
    );
  }
}

export default TimeCard;



// WEBPACK FOOTER //
// ./src/components/WeeklyCalendar/TimeCard.js